module.exports = __webpack_public_path__ + "img/4373f2417bd94a4cad13d6bb0e07cb49.7256f8de.jpg";